export default "__VITE_ASSET__CItnuhZu__"